import React, { useState, useEffect, useRef } from 'react';
import './apply-now.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import ThankYou from './ThankYou';
import {
  ArrowRight,
} from 'lucide-react';
import applyNowImg from '../assets/images/apply-now.png';

const API_BASE = 'https://mrrupya.in/Api/TaskApi';
const SITE_BASE = 'https://www.mrrupya.com';

const fetchCitiesFromApi = async (stateId) => {
    const resp = await axios.post(
        `${API_BASE}/getCity`,
        { state_id: String(stateId) },
        { headers: { 'Content-Type': 'application/json' } }
    );
    if (resp.data?.Status === 1 && Array.isArray(resp.data.Data)) {
        return resp.data.Data;
    }
    throw new Error(resp.data?.Message || 'Failed to load cities');
};

const ApplyNow = () => {

    const lastFetchedPanRef = useRef("");

    const [formData, setFormData] = useState({
        loanAmount: '',
        monthlyIncome: '',
        firstName: '',
        middleName: '',
        lastName: '',
        panNumber: '',
        dob: '',
        gender: '',
        mobile: '',
        altMobile: '',
        email: '',
        officialEmail: '',
        obligations: '',
        state: '',
        city: '',
        pincode: '',       
        city_name: "",
        state_name: "",
        term_and_condition: false,
    });

    const [errors, setErrors] = useState({});
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [pincodeList, setPincodeList] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [panExists, setPanExists] = useState(false);


    useEffect(() => {
        axios.get(`${API_BASE}/getState`)
        .then(res => {
            if (res.data.Status === 1) {
            setStates(res.data.Data);
            } else {
            alert(res.data.Message || 'Failed to fetch states');
            }
        })
        .catch(err => {
            console.error('Failed fetching states:', err);
            alert('Could not load states');
        });
    }, []);

   const handleChange = (e) => {
    let { id, value, type, checked } = e.target;
    let error = "";

    // PAN logic
    if (id === "panNumber") {
      value = value.toUpperCase().trim();

      if (lastFetchedPanRef.current && value !== lastFetchedPanRef.current) {
        setFormData(prev => ({
          ...prev,
          firstName: "", middleName: "", lastName: "", dob: "",
          gender: "", mobile: "", altMobile: "", email: "",
          officialEmail: "", obligations: "", pincode: "",
          city_name: "", state_name: "", term_and_condition: false
        }));

        setStateId("");
        setCityId("");
        lastFetchedPanRef.current = "";
      }

      // Is line ki wajah se error aa raha tha:
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/; 

      if (value.length === 10) {
        if (!panRegex.test(value)) {
          error = "Invalid PAN format";
        } else {
          setFormData(prev => ({ ...prev, [id]: value }));
          checkPanVal(value);
          return; 
        }
      }
    }

    // Mobile validation
    if ((id === "mobile" || id === "altMobile") && value.length > 0 && value.length !== 10) {
      error = "Enter 10-digit number";
    }

    setFormData(prev => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value
    }));

    setErrors(prev => ({
      ...prev,
      [id]: error
    }));
};

    // ✅ 👇 Paste this RIGHT BELOW handleChange
    const handleKeyPress = (e, fieldName) => {
    if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
        setErrors(prev => ({
        ...prev,
        [fieldName]: 'Only digits are allowed',
        }));
    } else {
        // Clear the error if valid key is pressed
        setErrors(prev => ({
        ...prev,
        [fieldName]: '',
        }));
    }
    };


    const handleStateChange = async (e) => {
        const sid = e.target.value;
        const selectedState = states.find(s => s.state_id.toString() === sid);

        setFormData(prev => ({ ...prev, state: selectedState?.state || '', city: '', pincode: '' }));
        setStateId(sid);
        setCityId('');
        setCities([]);
        setPincodeList([]);
        setErrors(prev => ({ ...prev, state: '', city: '', pincode: '' }));

        if (!sid) return;

        try {
            const cityList = await fetchCitiesFromApi(sid);
            setCities(cityList);
            if (cityList.length === 0) {
                setErrors(prev => ({ ...prev, city: 'No cities found for this state' }));
            }
        } catch (err) {
            console.error('getCity API failed:', err);
            setCities([]);
            setErrors(prev => ({
                ...prev,
                city: 'Could not load cities from server. Please try again later.',
            }));
        }
    };

    const handleCityChange = async (e) => {
        const cid = e.target.value;
        const selectedCity = cities.find(c => c.city_id.toString() === cid);

        setFormData(prev => ({
        ...prev,
        city: selectedCity?.city || '',
        pincode: ''
        }));
        setCityId(cid);
        setErrors(prev => ({ ...prev, city: '', pincode: '' }));

        try {
        const resp = await axios.post(
            `${API_BASE}/getPincodeByCityId`,
            { city_id: cid },
            { headers: { 'Content-Type': 'application/json' } }
        );

        if (resp.data.Status === 1) {
            setPincodeList(resp.data.Data);
        } else {
            setPincodeList([]);
        }
        } catch (err) {
        console.error('Failed fetching pincodes:', err);
        setPincodeList([]);
        }
    };


    const checkPanVal = async (pan) => {
        try {
          const resp = await axios.get(
            `${API_BASE}/checkGetCustomerbyPan`,
            { params: { pancard: pan } }
          );
      
          if (resp.data.status === true) {
            const d = resp.data.data;
            console.log("Customer Data Found:", d);
      
            lastFetchedPanRef.current = pan;
      
            // 1. Pehle data autofill karo (Taaki status kuch bhi ho, details bhar jayein)
            setFormData(prev => ({
              ...prev,
              firstName: d.first_name || "",
              middleName: d.middle_name || "",
              lastName: d.sur_name || "",
              dob: d.dob || "",
              gender: d.gender || "",
              mobile: d.mobile || "",
              altMobile: d.alternate_mobile || "",
              email: d.email || "",
              officialEmail: d.alternate_email || "",
              obligations: d.obligations ? String(parseInt(d.obligations, 10)) : "",
              pincode: d.pincode || "",
              city_name: d.city_name || "",
              state_name: d.state_name || "",
              city: d.city_name || "",
              state: d.state_name || "",
              term_and_condition: d.term_and_condition === "YES"
            }));
      
            setStateId(d.state_id || "");
            setCityId(d.city_id || "");

            if (d.state_id && !d.city_name) {
              try {
                const cityList = await fetchCitiesFromApi(d.state_id);
                setCities(cityList);
              } catch (err) {
                console.error('getCity API failed:', err);
                setCities([]);
              }
            }
      
           // ... existing logic inside checkPanVal ...
if (d.status === "CLOSED" || d.status === "REJECT" || d.status === "REJECTED") {
    setPanExists(false); 
    setErrors(prev => ({
        ...prev,
        panNumber: `Latest Status: ${d.status} (You can re-apply)`
    }));
} else {
    setPanExists(true); 
    setErrors(prev => ({
        ...prev,
        panNumber: `Your loan status is ${d.status}. Cannot re-apply.`
    }));
}
      
          } else {
            // Agar PAN database mein nahi mila (Naya Customer)
            setPanExists(false);
            setErrors(prev => ({ ...prev, panNumber: "" }));
            lastFetchedPanRef.current = "";
          }
      
        } catch (err) {
          console.error("PAN Check Error:", err);
          setPanExists(false);
          setErrors(prev => ({ ...prev, panNumber: "" }));
        }
      };


    const validate = () => {
    const newErrors = {};
    const onlyDigits = /^\d+$/;

    if (!formData.loanAmount) {
      newErrors.loanAmount = 'Required';
    } else if (Number(formData.loanAmount) > 100000) {
      newErrors.loanAmount = 'Maximum loan amount is ₹1,00,000';
    }
    if (!formData.monthlyIncome) newErrors.monthlyIncome = 'Required';
    if (!formData.firstName) newErrors.firstName = 'Required';
    if (!formData.panNumber) newErrors.panNumber = 'Required';
    if (!formData.dob) newErrors.dob = 'Required';
    if (!formData.gender) newErrors.gender = 'Required';

    if (!formData.mobile) {
        newErrors.mobile = 'Required';
    } else if (!onlyDigits.test(formData.mobile) || formData.mobile.length !== 10) {
        newErrors.mobile = 'Enter valid 10-digit mobile number';
    }

    if (!formData.altMobile) {
        newErrors.altMobile = 'Required';
    } else if (!onlyDigits.test(formData.altMobile) || formData.altMobile.length !== 10) {
        newErrors.altMobile = 'Enter valid 10-digit mobile number';
    }

    if (!formData.email) newErrors.email = 'Required';

    const obligationsData = formData.obligations ? Math.floor(Number(formData.obligations)).toString() : '';

    if (obligationsData && !/^\d+$/.test(obligationsData)) { 
        newErrors.obligations = 'Obligations must be numeric';
    }

    if (!formData.state) newErrors.state = 'Required';
    if (!formData.city) newErrors.city = 'Required';
    if (!formData.pincode) newErrors.pincode = 'Required';

  
if (!formData.term_and_condition) {
    newErrors.term_and_condition = 'Please accept the terms';
}

    return newErrors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const formErrors = validate();
        
        if (Object.keys(formErrors).length) {
            setErrors(formErrors);
            return;
        }
    
        const payload = {
            loan_amount: formData.loanAmount,
            monthly_income: formData.monthlyIncome,
            first_name: formData.firstName,
            middle_name: formData.middleName || null,
            sur_name: formData.lastName || null,
            pan: formData.panNumber,
            pan_status: 0,
            dob: formData.dob,
            gender: formData.gender.toUpperCase(),
            mobile: formData.mobile,
            alternate_mobile: formData.altMobile || null,
            otp: 1234,
            email_personal: formData.email,
            email_official: formData.officialEmail || null,
            obligations: formData.obligations || null,
            state_id: stateId,
            city: cityId,
            pin: formData.pincode,
            term_and_condition: formData.term_and_condition ? 'YES' : 'NO', 
            ip: '106.219.215.60',
            coordinates: null,
            source: 'MRRUPYA',
            lead_data_source_id: 38,
            utm_source: '',
            utm_campaign: null,
        };
    
        try {
            const resp = await axios.post(
                `${API_BASE}/saveLendingPage`,
                payload,
                { headers: { 'Content-Type': 'application/json' } }
            );
    
            if (resp.data.Status === 1) {
                setFormSubmitted(true);
                const trackingLink = `${SITE_BASE}/check`; 
                const smsVariables = `${formData.firstName}| ${trackingLink}|`;
                // const smsUrl = `https://www.fast2sms.com/dev/bulkV2?authorization=CNHnel3FiDU6P0GXQh7yVuMzER5cI4pogAJsBS9kxKbZaw1Y2LN8cOnHPz3G2QdRbeom7UJsfKviLyMZ&route=dlt&sender_id=VMCRED&message=207219&variables_values=${encodeURIComponent(smsVariables)}&flash=0&numbers=${encodeURIComponent(formData.mobile)}`;
    
                try {
                    // const smsResp = await axios.get(smsUrl);
                    // console.log("SMS API response:", smsResp.data);
                } catch (smsErr) {
                    console.error("SMS API error:", smsErr);
                }
            } else {
                const plainTextMessage = resp.data.Message.replace(/<[^>]+>/g, "\n").trim();
                alert(plainTextMessage || "Submit failed");
            }
        } catch (err) {
            console.error('Submit error:', err);
            alert('Submit failed');
        }
    };

    if (formSubmitted) {
        return <ThankYou />;
    }

    return (
        <section className="an-section">
            <div className="an-bg" aria-hidden="true">
                <div className="an-bg-gradient" />
                <div className="an-bg-mesh" />
                <div className="an-bg-dots" />
                <span className="an-bg-orb an-bg-orb--1" />
                <span className="an-bg-orb an-bg-orb--2" />
            </div>

            <div className="an-wrap">
                <div className="an-shell">
                    <aside className="an-visual" aria-label="Apply for MR Rupya loan">
                        <img
                            src={applyNowImg}
                            alt="Ready to take the next step — apply for your MR Rupya loan"
                            className="an-visual-img"
                        />
                    </aside>

                    <div className="an-form-panel">
                        <div className="an-form-head">
                            <h2>Apply for loan</h2>
                            <p>All fields marked <span className="required">*</span> are mandatory</p>
                        </div>

                        <Form onSubmit={handleSubmit} noValidate className="an-form">
            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="loanAmount" className="an-field">
                    <Form.Label>Loan Amount <span className="required">*</span></Form.Label>
                    <Form.Control
                    type="number"
                    value={formData.loanAmount}
                    onChange={handleChange}
                    isInvalid={!!errors.loanAmount}
                    />
                    <Form.Control.Feedback type="invalid">{errors.loanAmount}</Form.Control.Feedback>
                </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="monthlyIncome" className="an-field">
                    <Form.Label>Monthly Income <span className="required">*</span></Form.Label>
                    <Form.Control
                    type="number"
                    value={formData.monthlyIncome}
                    onChange={handleChange}
                    isInvalid={!!errors.monthlyIncome}
                    />
                    <Form.Control.Feedback type="invalid">{errors.monthlyIncome}</Form.Control.Feedback>
                </Form.Group>
                </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="panNumber" className="an-field">
                    <Form.Label>PAN Number <span className="required">*</span></Form.Label>
                    <Form.Control
                    type="text"
                    maxLength="10"
                    value={formData.panNumber}
                    onChange={handleChange}
                    isInvalid={!!errors.panNumber}
                    />
                    <Form.Control.Feedback type="invalid">{errors.panNumber}</Form.Control.Feedback>
                </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="firstName" className="an-field">
                    <Form.Label>First Name <span className="required">*</span></Form.Label>
                    <Form.Control
                    type="text"
                    value={formData.firstName}
                    onChange={handleChange}
                    isInvalid={!!errors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
                </Form.Group>
                </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="middleName" className="an-field">
                    <Form.Label>Middle Name</Form.Label>
                    <Form.Control
                    type="text"
                    value={formData.middleName}
                    onChange={handleChange}
                    />
                </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="lastName" className="an-field">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                    type="text"
                    value={formData.lastName}
                    onChange={handleChange}
                    />
                </Form.Group>
                </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="dob" className="an-field">
                    <Form.Label>Date of Birth <span className="required">*</span></Form.Label>
                    <Form.Control
                    type="date"
                    value={formData.dob}
                    onChange={handleChange}
                    isInvalid={!!errors.dob}
                    />
                    <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="gender" className="an-field">
                    <Form.Label>Gender <span className="required">*</span></Form.Label>
                    <Form.Select
                    value={formData.gender}
                    onChange={handleChange}
                    isInvalid={!!errors.gender}
                    >
                    <option value="">Select Gender</option>
                    <option value="MALE">MALE</option>
                    <option value="FEMALE">FEMALE</option>
                    <option value="OTHER">OTHER</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">{errors.gender}</Form.Control.Feedback>
                </Form.Group>
                </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
    <Form.Group controlId="mobile" className="an-field">
    <Form.Label>Mobile <span className="required">*</span></Form.Label>
    <Form.Control
        type="tel"
        maxLength="10"
        value={formData.mobile}
        onChange={handleChange}
        onKeyPress={(e) => handleKeyPress(e, 'mobile')}
        isInvalid={!!errors.mobile}
    />
    {errors.mobile && <div className="text-danger">{errors.mobile}</div>}
    </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
    <Form.Group controlId="altMobile" className="an-field">
    <Form.Label>Alternate Mobile <span className="required">*</span></Form.Label>
    <Form.Control
        type="tel"
        maxLength="10"
        value={formData.altMobile}
        onChange={handleChange}
        onKeyPress={(e) => handleKeyPress(e, 'altMobile')}
        isInvalid={!!errors.altMobile}
    />
    {errors.altMobile && <div className="text-danger">{errors.altMobile}</div>}
    </Form.Group>
                </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="email" className="an-field">
                    <Form.Label>Email <span className="required">*</span></Form.Label>
                    <Form.Control
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
                <Form.Group controlId="officialEmail" className="an-field">
                    <Form.Label>Official Email</Form.Label>
                    <Form.Control
                    type="email"
                    value={formData.officialEmail}
                    onChange={handleChange}
                    />
                </Form.Group>
                </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
    <Form.Group controlId="obligations" className="an-field">
    <Form.Label>Obligations</Form.Label>
    <Form.Control
        type="text"
        maxLength="7"
        value={formData.obligations}
        onChange={handleChange}
        onKeyPress={(e) => handleKeyPress(e, 'obligations')}
        isInvalid={!!errors.obligations}
    />
    {errors.obligations && <div className="text-danger">{errors.obligations}</div>}
    </Form.Group>
                </Col>
                <Col xs={12} sm={6} className="an-form-col">
                    <Form.Group controlId="state" className="an-field">
                        <Form.Label>
                        State <span className="required">*</span>
                        </Form.Label>

                        {formData.state_name !== '' ? (
                        <>
                            <Form.Control
                            type="hidden"
                            name="state_id"
                            value={formData.state_id}
                            />
                            <Form.Control
                            type="text"
                            value={formData.state_name}
                            readOnly
                            />
                        </>
                        ) : (
                        <Form.Select
                            value={stateId}
                            onChange={handleStateChange}
                            isInvalid={!!errors.state}
                        >
                            <option value="">Select State</option>
                            {states.map(s => (
                            <option key={s.state_id} value={s.state_id}>
                                {s.state}
                            </option>
                            ))}
                        </Form.Select>
                        )}

                        <Form.Control.Feedback type="invalid">
                        {errors.state}
                        </Form.Control.Feedback>
                    </Form.Group>
                    </Col>
            </Row>

            <Row className="an-form-row g-3">
                <Col xs={12} sm={6} className="an-form-col">
                    <Form.Group controlId="city" className="an-field">
                        <Form.Label>City</Form.Label>

                        {formData.city_name !== '' ? (
                        <>
                            <Form.Control
                            type="hidden"
                            name="city_id"
                            value={formData.city_id}
                            />
                            <Form.Control
                            type="text"
                            value={formData.city_name}
                            readOnly
                            />
                        </>
                        ) : (
                        <Form.Select value={cityId} onChange={handleCityChange}>
                            <option value="">Select City</option>
                            {cities.map(city => (
                            <option key={city.city_id} value={city.city_id}>
                                {city.city}
                            </option>
                            ))}
                        </Form.Select>
                        )}

                    </Form.Group>
                    </Col>
                <Col xs={12} sm={6} className="an-form-col">
                    <Form.Group controlId="pincode" className="an-field">
                        <Form.Label>Pincode</Form.Label>

                        {formData.pincode !== '' ? (
                            <Form.Control
                            type="text"
                            value={formData.pincode}
                            readOnly
                            />
                        ) : pincodeList.length > 0 ? (
                            <Form.Select
                            value={formData.pincode}
                            onChange={handleChange}
                            disabled={!cityId}
                            >
                            <option value="">Select Pincode</option>
                            {pincodeList.map(pin => (
                                <option
                                key={pin.m_pincode_id}
                                value={pin.m_pincode_value}
                                >
                                {pin.m_pincode_value}
                                </option>
                            ))}
                            </Form.Select>
                        ) : (
                            <Form.Control
                            type="text"
                            id="pincode"
                            name="pincode"
                            maxLength={6}
                            placeholder="Enter 6-digit pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                            disabled={!cityId}
                            isInvalid={!!errors.pincode}
                            />
                        )}

                        {errors.pincode && (
                            <div className="text-danger">{errors.pincode}</div>
                        )}
                        </Form.Group>

                </Col>
            </Row>

                            <div className="an-form-footer">
            <Form.Group controlId="term_and_condition" className="an-field terms-check">
  <Form.Check
    type="checkbox"
    label={
      <>
        <a href="/terms-conditions" target="_blank">Terms & Conditions</a> <span className="required">*</span>
      </>
    }
    checked={formData.term_and_condition}
    onChange={handleChange} // <-- Yeh change kiya
    isInvalid={!!errors.term_and_condition}
  />
  {errors.term_and_condition && (
    <div className="text-danger">
      {errors.term_and_condition}
    </div>
  )}
</Form.Group>

<p className="declaration-text">
  I hereby declare that all the above information provided by me is true, correct, and verified to the best of my knowledge.
</p>

<div className="submit-btn-wrapper">
<Button
    type="submit"
    className="apply-submit-btn"
    disabled={panExists === true && !errors.panNumber?.includes("REJECT")}
>
    Submit application
    <ArrowRight size={18} aria-hidden="true" />
</Button>
</div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </section>
    );
    };

    export default ApplyNow;
